import { ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { Th, Flex, Thead, Tr, Checkbox, Box, Tooltip } from '@chakra-ui/react';
import { useEffect } from 'react';
import { AppColors } from '../../../theme';
import { AppText } from '../../app-text/app-text';
import { TableHeaderProps, ColumnSortDir } from '../app-data-table-types';

export const TableHeader = <T extends {}>({
  columns,
  onSortByColumn,
  onSelectAll,
  selectAll,
  selectableRows,
}: TableHeaderProps<T>): JSX.Element => {
  useEffect(() => {}, [columns]);

  const headers = columns.map((column, index) => {
    const style = {
      width: column.width ?? 100,
      backgroundColor: AppColors.appBorder,
    };

    return (
      <Th
        key={`headCell-${index}`}
        style={style}
        onClick={() => {
          onSortByColumn && column.headerSortable && onSortByColumn(column);
        }}
        position={column.stickyColumn ? 'sticky' : 'unset'}
        top={0}
        right={0}
        bg={'white'}
        zIndex={2}
        paddingY={4}
        fontFamily={'inherit'}
      >
        <Flex flexDirection={'row'} justifyContent={'space-between'}>
          <Tooltip label={column.headerMeta ?? ''}>
            <Box>
              <AppText
                _hover={{
                  cursor: column.headerSortable ? 'pointer' : 'auto',
                }}
                fontWeight={'600'}
                fontSize={'14px'}
                color={'#222222'}
              >
                {column.header.toUpperCase()}
              </AppText>
            </Box>
          </Tooltip>
          {column.headerSortDir === ColumnSortDir.Asc && (
            <ChevronUpIcon boxSize={6} color={AppColors.secondary} />
          )}
          {column.headerSortDir === ColumnSortDir.Desc && (
            <ChevronDownIcon boxSize={6} color={AppColors.secondary} />
          )}
        </Flex>
      </Th>
    );
  });

  return (
    <Thead>
      <Tr width={'30px'}>
        {selectableRows && (
          <Th
            position={'sticky'}
            top={0}
            bg={'white'}
            width={30}
            py={6}
            zIndex={2}
            bgColor={AppColors.appBorder}
          >
            <Tooltip label={'Select all rows'}>
              <Flex>
                <Checkbox
                  isChecked={selectAll}
                  onChange={(e) => {
                    onSelectAll && onSelectAll();
                  }}
                ></Checkbox>
              </Flex>
            </Tooltip>
          </Th>
        )}
        {headers}
      </Tr>
    </Thead>
  );
};
